var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    fill: "none",
    strokeMiterlimit: 10,
    width: 22,
    height: 26
  }), /*#__PURE__*/React.createElement("line", {
    strokeMiterlimit: 10,
    x1: 8,
    y1: 12,
    x2: 20,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    strokeMiterlimit: 10,
    x1: 8,
    y1: 18,
    x2: 20,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    strokeMiterlimit: 10,
    x1: 8,
    y1: 24,
    x2: 12,
    y2: 24
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    strokeMiterlimit: 10,
    points: " 6,1 29,1 29,28 "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.998d71ba8b25b53b530363a4bb4e53fe.svg";
export { ForwardRef as ReactComponent };